import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from 'src/app/modules/auth';
import { environment } from 'src/environments/environment';
import { first } from 'rxjs/operators';

const API_BASE_URL = `${environment.baseUrl}notificationHub`;

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private static initialized = false;
  private hubConnection: signalR.HubConnection;
  newNotificationCount = new BehaviorSubject<number>(0);

  constructor(private authService: AuthService,
  ) {
  }

  public ensureInitialized() {
    if (SignalRService.initialized) {
      return;
    }
    SignalRService.initialized = true;
    this.authService.currentUser$
      .pipe(first())
      .subscribe(user => {
        if (!user) {
          return;
        }
        this.hubConnection = new signalR.HubConnectionBuilder()
          .withUrl(API_BASE_URL, {accessTokenFactory: () => user.jwToken}).withAutomaticReconnect().build();
        this.hubConnection.start().then(() => console.log('Connection started'))
          .catch(err => console.log('Error while starting connection: ' + err));
        this.hubConnection.on('ReceiveMessage', data => this.newNotificationCount.next(data));
      });
  }

  public stop() {
    this.hubConnection.stop()
      .then(() => console.log('Connection stopped'))
      .catch(err => console.log('Error while stopping connection: ' + err));
  }
}
